import { PageStepType } from './PageTypes';

export interface CodeBranch
{
	name: string;
	commands: PageStepType[];
	allowList: string[];
	userData: any;
};

export class BranchManager
{
	private branchQueue: (CodeBranch | undefined)[] = [undefined];
	private branchCurrent: (CodeBranch | undefined) = undefined;

	constructor()
	{
	}

	/** Return the name of the current branch of "" empty string if there is no current branch */
	getBranchName(): string
	{
		if (!this.branchCurrent) return "";
		return this.branchCurrent.name;
	}

	/** Returns a list of all current branches with the 0 index being the top most branch */
	getBranchList(): string[]
	{
		let resultList: string[] = [];
		if (this.branchQueue)
		{
			for (const branch of this.branchQueue)
			{
				if (branch && branch.name)
					resultList.push(branch.name);
			}
		}

		if (this.branchCurrent) resultList.push(this.branchCurrent.name);

		return resultList.reverse();
	}

	/** Return a copy of an existing branch if that branch is valid */
	duplicateBranch(source: CodeBranch | undefined)
	{
		let newBranch: CodeBranch = {
			commands: [],
			allowList: [],
			name: "",
			userData: undefined
		};

		if (source)
		{
			newBranch.commands = [...source.commands];
			newBranch.allowList = [...source.allowList];
			newBranch.name = source.name;
			newBranch.userData = source.userData;
		}

		return newBranch;
	}

	/**
	* Start a new code branch.  The previous is added to a queue which
	* is loaded again after we end this branch.
	*/
	startBranch(branchName: string, allowList: string[], optionalUserData?: any)
	{
		this.branchQueue.push(this.branchCurrent);
		this.branchCurrent = {
			commands: [],
			allowList: allowList,
			name: branchName,
			userData: optionalUserData
		};
	}

	/** Add an item to the current branch */
	addItem(item: PageStepType)
	{
		if (!this.branchCurrent)
		{
			throw "Attempting to add a command where a branch doesn't exist.";
		}

		this.branchCurrent.commands.push(item);
	}

	/**
	 * End the current branch and restore the previous.
	 * The previous may not exist or be empty which is fine.
	 */
	endBranch(): CodeBranch
	{
		let result = this.duplicateBranch(this.branchCurrent);

		this.branchCurrent = undefined;

		if (this.branchQueue.length > 0)
			this.branchCurrent = this.branchQueue.pop();

		return result;
	}

	/** Return true if there is currently a branch being used */
	hasCurrent(): boolean
	{
		if (this.branchCurrent)
			return true;

		return false;
	}

	/** Returns true if the current branch is active and waiting for a specific command
	For example, if the current branch is started with "Begin List" then this function
	will return TRUE if you ask "End List" but all other commands return FALSE
	*/
	isAllowList(command: string): boolean
	{
		if (!this.branchCurrent) return false;

		if (this.branchCurrent.allowList.indexOf(command) !== -1)
		{
			return true;
		}

		return false;
	}


};
